import { BaseDto } from './base.dto';
import { FixReportDto } from './fixReport.dto';
import { UserDto } from './user.dto';

export class FixCalloutDto extends BaseDto {
  id: number;
  fixReportId?: number;
  fixReport?: FixReportDto; 
  engineerName: string;
  companyName: string;
  arrivalDateTime: Date;
  departureDateTime: Date;
  calloutUserId?: number;
  calloutUser: UserDto; 
  workComplete: number;
  workDetails: string;
}
